import React from "react";
import { Link } from "react-router-dom";
import { MEDIA_URL } from "../../../configs";
import TimeAgo from "react-timeago";

const RecentUploadList = ({ recentData }) => (
  <div className="mb-4 px-4 py-3 bg-white shadow rounded-4">
    <div className="d-flex justify-content-between mb-4 border-bottom pb-2">
      <strong>Recent uploaded</strong>
      <span className="text-muted">
        <i className="bi bi-three-dots-vertical"></i>
      </span>
    </div>
    {recentData && recentData.length > 0 ? (
      <ul className="list-unstyled">
        {recentData.map((resource, index) => (
          <li className="mb-2 d-flex align-items-center" key={index}>
            <div style={{ minWidth: 64, maxWidth: 64, height: 64, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {resource?.thumbnail ? (
                <Link to={`/resources/edit/${resource._id}`}>
                  <img
                    src={`${MEDIA_URL}${resource?.thumbnail?.path}`}
                    width={64}
                    height={64}
                    style={{ objectFit: 'cover', borderRadius: 8, background: '#f8f9fa' }}
                    className="img-fluid"
                    alt={`Thumbnail for ${resource.name || 'resource'}`}
                  />
                </Link>
              ) : (
                <div style={{ width: 64, height: 64, background: '#f8f9fa', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="bi bi-image text-muted" style={{ fontSize: 32 }}></i>
                </div>
              )}
            </div>
            <div className="flex-grow-1 ms-3">
              <p className="mb-1 small list-title">
                <Link to={`/resources/edit/${resource._id}`} className="text-dark">
                  {resource.name}
                </Link>
              </p>
              <div className="text-muted mb-2">
                {/* Add status and creator info if needed */}
                <div className="me-2 badge rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal py-1 px-2">
                    <i className="bi bi-clock me-1"></i>
                    <span className="text-break">
                      <TimeAgo date={resource.created_at} />
                    </span>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    ) : (
      <p className="text-muted">No recent uploads to show.</p>
    )}
  </div>
);

export default RecentUploadList;
